import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/client';
import { useAuthStore } from '../stores/auth.store';

export function useLogin() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { email: string; password: string }) => authApi.login(data),
    onSuccess: (response) => {
      const { user, tokens } = response.data;
      queryClient.clear();
      setAuth(user, tokens.accessToken, tokens.refreshToken);
      navigate('/dashboard');
    },
  });
}

export function useSsoConsume() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ticket: string) => authApi.ssoConsume(ticket),
    onSuccess: (response) => {
      const { user, tokens } = response.data;
      queryClient.clear();
      setAuth(user, tokens.accessToken, tokens.refreshToken);
      navigate('/dashboard', { replace: true });
    },
  });
}

export function useLogout() {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => authApi.logout(),
    onSettled: () => {
      queryClient.clear();
      logout();
      navigate('/login');
    },
  });
}

export function useCurrentUser() {
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);

  return useQuery({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const response = await authApi.me();
      setUser(response.data);
      return response.data;
    },
    initialData: user,
    enabled: !!user,
  });
}
